import { api } from "./api";

export interface User {
  _id: string;
  name: string;
  username: string;
  email: string;
  phone?: string;
  role: "admin" | "store_admin" | "operator" | "user";
  isApproved: boolean;
  isVerified: boolean;
  isBanned?: boolean;
  bannedAt?: string;
  bannedReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UsersListResponse {
  users: User[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface OrdersListResponse {
  orders: any[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const userApi = {
  async getUsers(params?: { page?: number; limit?: number; search?: string }): Promise<UsersListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", params.page.toString());
    if (params?.limit) queryParams.append("limit", params.limit.toString());
    if (params?.search) queryParams.append("search", params.search);
    const queryString = queryParams.toString();
    const response = await api.get(`/users/admin${queryString ? `?${queryString}` : ""}`);
    return response.data;
  },

  async getUser(id: string): Promise<User> {
    const response = await api.get(`/users/admin/${id}`);
    return response.data;
  },

  async getUserOrders(id: string, params?: { page?: number; limit?: number }): Promise<OrdersListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append("page", params.page.toString());
    if (params?.limit) queryParams.append("limit", params.limit.toString());
    const queryString = queryParams.toString();
    const response = await api.get(`/users/admin/${id}/orders${queryString ? `?${queryString}` : ""}`);
    return response.data;
  },

  async banUser(id: string, reason?: string): Promise<User> {
    const response = await api.put(`/users/admin/${id}/ban`, { reason });
    return response.data;
  },

  async unbanUser(id: string): Promise<User> {
    const response = await api.put(`/users/admin/${id}/unban`);
    return response.data;
  },
};
